import styled from 'styled-components';

export const Container = styled.div`
	padding: 0.8rem;
	background: var(--ticto-background);
	border-bottom: 1px solid var(--ticto-outline);

	p {
		margin: 0;
		font-size: 13px;
	}
`;
